import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";
import accessToken from "helpers/jwt-token-access/accessToken";

const useProfile = () => {
  const userProfileSession = getLoggedinUser();
  var token = accessToken;
  const [loading, setLoading] = useState(userProfileSession ? false : true);
  const [userProfile, setUserProfile] = useState(
    userProfileSession ? userProfileSession : null
  );

  useEffect(() => {
    const userProfileSession = getLoggedinUser();
    var token =accessToken;
    setUserProfile(userProfileSession ? userProfileSession : null);
    setLoading(token ? false : true);
  }, []);


  return { userProfile, loading, token };
};

export { useProfile };